<template>
    <div>
        <breadCrumb 
            :icon="'fa-star'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_points`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-show="selectedTab == 'summary' && filterObj.summaryType == 'date'" class="row mt-3">
            <div class="col-sm-6 col-xl-3" v-for="box in pointsReportSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <div v-show="selectedTab == 'summary' && filterObj.summaryType == 'customer'" class="row mt-3">
            <div class="col-sm-6 col-xl-3">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g bg-success-500">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{balance}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{$t('salon_report.header_balance')}}</small>
                        </h3>
                    </div>
                    <i class="fal fa-search-dollar position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportCreditTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <pointsFilter ref="pointsFilter" :tab="selectedTab" @setCreditBalance="setCreditBalance" @filterCreditSummary="filterCreditSummary" @filterCreditList="filterCreditList"></pointsFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-5">
                            <pointsSummary ref="pointsSummary" class="tab-pane" :class="{'active': selectedTab == 'summary'}" @setSummary="setSummary" @setBalanceSummary="setBalanceSummary" @setExportData="setExportData"></pointsSummary>               
                            <pointsList ref="pointsList" class="tab-pane" :class="{'active': selectedTab == 'list'}" @setExportData="setExportData"></pointsList>               
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import PointsFilter from './Points_Filter'
import PointsList from './Points_List'
import PointsSummary from './Points_Summary'

import box from './../../../../assets/js/dashboard/salonReport/salonReport'
import {setSummaryBoxLabel} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "reportPoints",
    components:{
        PointsFilter, PointsList, PointsSummary, BreadCrumb
    },
    data(){
        return {
            selectedTab: "summary",
            pointsReportSummaryBox: [],
            filterObj: {}, 
            summaryTab: "customer",
            balance: 0,
        }
    },
    watch:{
        selectedTab(value){
            value == 'list' ? this.$refs.pointsList.getCreditList(this.filterObj) : this.$refs.pointsSummary.handleCreditSummary(this.filterObj);
            this.$refs.pointsFilter.updateSummaryType(value);
        },
        "$i18n.locale"(val){
            this.setSummaryBoxLabel()
        }
    },
    methods:{
        async filterCreditSummary(filterObj){
            this.filterObj = filterObj;
            await this.$refs.pointsSummary.handleCreditSummary(this.filterObj);
        },
        filterCreditList(filterObj){
            this.filterObj = filterObj;
            this.$refs.pointsList.getCreditList(this.filterObj);
        },
        setSummary(data){
            for(var i=0; i<this.pointsReportSummaryBox.length; i++){
                switch(this.pointsReportSummaryBox[i].id){
                    case"top_up":
                        this.pointsReportSummaryBox[i].value = data.summary.topup;
                        break
                    case"redeem":
                        this.pointsReportSummaryBox[i].value = data.summary.redeem;
                        break
                }
            }
        },
        setCreditBalance(data){
            this.filterObj = data;
            this.$refs.pointsSummary.handleCreditSummary(data);
        }, 
        setBalanceSummary(total){
            this.balance = total
        },
        setExportData(data){
            this.$refs.pointsFilter.setExportData(data);
        },
        setSummaryBoxLabel(){
            var _box = box.creditReportSummaryBox
            this.pointsReportSummaryBox = setSummaryBoxLabel(this, 'credit', _box.slice())
        },
    },
    mounted(){
        let $vm = this
        $vm.setSummaryBoxLabel()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>